export { default as AnonymousRoutes } from './AnonymousRoutes';
